import React, { FC } from "react";
import VisaSVG from "./visa.svg";

type Props = JSX.IntrinsicAttributes;

export const VisaIcon: FC<Props> = (props) => {
  return <VisaSVG {...props} />;
};
